import { render, staticRenderFns } from "./MFAViewActivation.vue?vue&type=template&id=23326072&"
import script from "./MFAViewActivation.vue?vue&type=script&lang=ts&"
export * from "./MFAViewActivation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports